// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"497":"c61c6dd5","507":"e55f871a","855":"ffa9a200"}[chunkId] + ".css";
};